import {Component, h} from 'preact';
import {refreshOffers} from "../../utils/offers";

import {connect} from 'preact-redux';
import OfferCard from "../offercard/OfferCard";
import axios from "axios";

export function handleAjustIpotekaClick() {
    axios.post("https://widget-statistics.fin.cian.ru/widgets/events/finance-widget-offers-on-card", {name: "ajustIpoteka"}, {withCredentials: true});
}

export function maskPhone(phone) {
    return `${phone.substring(0, 9)}*** **${phone.substring(15)}`
}

class PopupInternal extends Component {

    sendCodeClicked(event) {
        axios.post("https://widget-statistics.fin.cian.ru/widgets/events/finance-widget-offers-on-card", {
            name: "send_code_pressed"
        }, { withCredentials: true });
        axios.post("https://authorization-service.fin.cian.ru/phone", {phone: this.props.userPhone}).then(r => r.data).then(data => {
            this.props.updateUUID(data.uuid);
            this.props.updateShowResend(false);
            setTimeout(() => this.props.updateShowResend(true), data.resendIn || 60000);
            this.props.updateScreen('CODE');
        });
        event.stopPropagation();
        event.preventDefault();
    };

    codeInput(e) {
        let value = e.target.value;
        if (value.length > 4) {
            value = value.substr(0, 4);
            e.target.value = value;
        }
        if (value.length === 4) {
            axios.post("https://authorization-service.fin.cian.ru/code", {
                uuid: this.props.uuid,
                code: value
            }, {withCredentials: true}).then(r => r.data).then(data => {
                if (data.ok) {
                    axios.post("https://widget-statistics.fin.cian.ru/widgets/events/finance-widget-offers-on-card", {
                        name: "valid_code_entered"
                    }, { withCredentials: true });
                    refreshOffers()
                }
            })
        }
    }


    constructor(props) {
        super(props);
    }

    render({offers, userPhone, screen, updatePhone, showResend}) {
        console.log({screen});
        if (offers.length) {
            if (offers[0].userId) {
                const offerCards = offers.map((offer, idx) => <OfferCard
                    id={`offer_${idx}`}
                    offer={offer}
                />);
                return <div className={'fw-offers_popup'} ref={this.props.popupRef}>
                    <div className={'fw-offers_popup_title_container'}>
                        <div className={'fw-offers_popup_title'}>Вот что вам одобрили</div>
                    </div>
                    {offerCards}
                </div>
            } else {
                if (userPhone) {
                    if (screen === 'CODE') {
                        return <div className={'fw-offers_popup'} ref={this.props.popupRef}>
                            <div className={'fw-offers_sms_title'}>Введите код из СМС</div>
                            <div className={'fw-offers_sms_subtitle'}>Не получили сообщение? Подождите 60 секунд и
                                попробуйте снова
                            </div>
                            <div className={'fw-offers_sms_inputtitle'}>Код из СМС</div>
                            <div className={'fw-offers_sms_inputcontainer'}>
                                <input onClick={e => e.stopPropagation()} onInput={this.codeInput.bind(this)}
                                       className={'fw-offers_sms_input'}/>
                                {showResend ?
                                    <div className={'fw-offers_sms_resend'} onClick={this.sendCodeClicked.bind(this)}>Не
                                        получил смс</div> : null}
                            </div>
                        </div>
                    } else {
                        axios.post("https://widget-statistics.fin.cian.ru/widgets/events/finance-widget-offers-on-card", {
                            name: "phone_to_auth"
                        }, { withCredentials: true });
                        return <div className={'fw-offers_popup'} ref={this.props.popupRef}>
                            <div className={'fw-offers_sms_title'}>Чтобы посмотреть одобренные предложения,
                                авторизуйтесь
                            </div>
                            <div className={'fw-offers_sms_subtitle'}>
                                <span>На номер</span>
                                <span style={{fontWeight: 'bold'}}>{maskPhone(userPhone)}</span>
                                <span>, мы отправим СМС с кодом авторизации</span>
                            </div>
                            <div onClick={this.sendCodeClicked.bind(this)} className={'fw-offers_sms_button'}>Отправить
                                код
                            </div>
                        </div>
                    }
                } else {
                    axios.get("https://www.cian.ru/cf/offer-selector/api/get-my-phone", {withCredentials: true}).then(r => r.data).then(data => {
                        updatePhone(data.phones[0])
                    });
                }
            }
        }
        return null;
    }

}

const Popup = connect(
    state => state, dispatch => {
        return {
            updatePhone: phone => dispatch({
                type: 'USER_PHONE',
                userPhone: phone
            }),
            updateScreen: screen => dispatch({
                type: 'SCREEN',
                screen: screen
            }),
            updateUUID: uuid => dispatch({
                type: 'UUID',
                uuid: uuid
            }),
            updateShowResend: showResend => dispatch({
                type: 'SHOW_RESEND',
                showResend: showResend
            })
        }
    })
(PopupInternal);


export default Popup;
